import React from "react";
import { CheckCircle2, Circle, Clock } from "lucide-react";

const STAGE_LABELS = {
    order_received: "Order Received",
    photos_verified: "Photos Verified",
    production: "Production",
    printing_3d: "3D Printing",
    painting: "Painting",
    quality_check: "Quality Check",
    packing: "Packing",
    shipping: "Shipping",
    delivered: "Delivered",
};

const STAGES = Object.keys(STAGE_LABELS);

const OrderTimeline = ({ currentStage = "order_received", history = [] }) => {
    const currentIdx = STAGES.indexOf(currentStage);
    return (
        <div className="space-y-2" data-testid="order-timeline">
            {STAGES.map((stage, idx) => {
                const isDone = idx < currentIdx;
                const isCurrent = idx === currentIdx;
                const entry = history.find((h) => h.stage === stage);
                return (
                    <div key={stage} className={`flex items-start gap-4 p-3 rounded-2xl ${isCurrent ? "bg-primary/10" : ""}`}>
                        <div className="mt-0.5">
                            {isDone ? (
                                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                            ) : isCurrent ? (
                                <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center">
                                    <Clock className="w-3 h-3 text-primary-foreground" />
                                </div>
                            ) : (
                                <Circle className="w-5 h-5 text-muted-foreground/30" />
                            )}
                        </div>
                        <div className="flex-1">
                            <div className={`text-sm font-medium ${isCurrent ? "text-primary" : isDone ? "text-foreground" : "text-muted-foreground"}`}>
                                {STAGE_LABELS[stage]}
                            </div>
                            {entry?.note && <div className="text-xs text-muted-foreground">{entry.note}</div>}
                            {entry?.at && <div className="text-[11px] text-muted-foreground mt-0.5">{new Date(entry.at).toLocaleString()}</div>}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default OrderTimeline;
